var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 100,
    viewBox: "0 0 85 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.00976562 0L7.67267 90L42.0806 100L76.4765 90.0063L84.1514 0H0.00976562Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M67.7674 29.4311L66.7998 40.7374L63.8789 74.6311L42.0802 80.8999L42.0622 80.9061L20.2755 74.6311L18.7549 56.9061H29.4289L30.2222 66.0999L42.0682 69.4249L42.0742 69.4186L53.9382 66.0936L55.5549 50.7749L18.2441 50.8811L17.1863 40.4061L56.4504 39.9249L57.2437 28.7124L16.1345 28.8311L15.4434 18.3999H42.0802H68.717L67.7674 29.4311Z",
    fill: "#FAFAFA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3);
export default __webpack_public_path__ + "static/media/css3.23aac571bde95e7f24f203fc9f00b480.svg";
export { ForwardRef as ReactComponent };